import { EMessageFileTypes } from './messageFiles';
import { IWsFileMessage } from '../actions/wsMessage/types';
import { IChatFilesResponseSchema } from '../repositories/chats/entities/file/ChatFilesResponseSchema';
import { ICancellationToken } from '../utils/cancelationToken';

export enum EUploadFilesStatus {
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
  WsSucceed = 'wsSucceed',
}

export type TMessageFiles = {
  blobFiles?: TPendingBlobFile[];
  uploadedFiles?: IWsFileMessage[];
  status: EUploadFilesStatus;
};

export type TPendingBlobFile = {
  file: File;
  cancellationToken: ICancellationToken;
  type: EMessageFileTypes;
};

export type { IChatFilesResponseSchema as TGetLatestChatFilesResponse };
